import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const DISPLAY_NAME = 'AccordionTitle';
const Root = styled.div.withConfig({
  displayName: "AccordionTitle__Root",
  componentId: "sc-uk1kxw-0"
})(["flex:1;min-width:0;"]);
const AccordionTitle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      title
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref
  }), title);
});
AccordionTitle.displayName = DISPLAY_NAME;
AccordionTitle.Style = Root;
process.env.NODE_ENV !== "production" ? AccordionTitle.propTypes = {
  /**
   * Sets the title.
   */
  title: PropTypes.string.isRequired
} : void 0;
export default AccordionTitle;